import { useDispatch } from 'react-redux';
import { ApiError } from 'services/api';
import { useDeleteEspAccount } from 'api/ESPAccountsAPI';
import { addNegativeToast, addPositiveToast } from 'modules/toastContainer';
import { useModalsContext, useSendingPlatformsQueryContext } from '../contexts';

export const useDeleteAccount = () => {
  const dispatch = useDispatch();
  const { hideModal } = useModalsContext();
  const { refetchEspAccounts } = useSendingPlatformsQueryContext();

  const { mutate: deleteAccount } = useDeleteEspAccount({
    onSuccess: () => {
      refetchEspAccounts();
      dispatch(addPositiveToast('Successfully disconnected account.'));
      hideModal();
    },
    onError: (e: unknown) => {
      const errorText = (e as ApiError)?.response?.data;
      dispatch(addNegativeToast(errorText));
      hideModal();
    },
  });

  return deleteAccount;
};
